import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiTrendingUp, FiArrowRight } = FiIcons;

const CTA = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleBookDemo = () => {
    window.open('https://calendly.com/fishinnovation/engagedent-ai-discovery-call', '_blank');
  };

  return (
    <section id="cta" className="py-24 bg-gradient-to-r from-slate-gray to-dental-blue">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-6xl font-bold text-clean-white mb-6">
            Ready to{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-growth-green to-energy-coral">
              Grow Smarter?
            </span>
          </h2>
          
          <p className="text-xl md:text-2xl text-clean-white opacity-90 max-w-4xl mx-auto leading-relaxed mb-12">
            Whether you want to fill chairs, simplify patient financing, or free your staff from admin, 
            EngageDent Ai has the solution. Book a demo today and see how fast your practice can grow.
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <motion.button
              onClick={handleBookDemo}
              className="bg-energy-coral text-clean-white px-8 py-4 rounded-xl font-semibold text-lg flex items-center space-x-3 hover:bg-opacity-90 transition-all duration-200 shadow-2xl"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiCalendar} className="text-xl" />
              <span>Book a Demo</span>
            </motion.button>

            <motion.button
              onClick={() => scrollToSection('roi')}
              className="bg-clean-white text-dental-blue px-8 py-4 rounded-xl font-semibold text-lg flex items-center space-x-3 hover:bg-opacity-90 transition-all duration-200 shadow-2xl"
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiTrendingUp} className="text-xl" />
              <span>See ROI Potential</span>
            </motion.button>
          </div>

          {/* Trust indicators */}
          <motion.div
            className="mt-16 grid md:grid-cols-3 gap-8"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <div className="text-center">
              <div className="text-3xl font-bold text-clean-white mb-2">Quick Integration</div>
              <p className="text-clean-white opacity-80">Get started immediately</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-clean-white mb-2">Custom Demo</div>
              <p className="text-clean-white opacity-80">Tailored to your practice</p>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-clean-white mb-2">24/7 Support</div>
              <p className="text-clean-white opacity-80">We're here when you need us</p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTA;